import type { AccessAndIDTokenResponse } from '@local/login/apiClients/types';
import { setCombinedToken } from '@local/login/store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { LEGACY_TOKEN_TYPE, ROUTES } from 'src/utils/strings';

/*
 * Receives the apiToken handed back by the enterprise SSO callback
 * (e.g. /login/auth/<apiToken>), persists it, then drops the user into the app.
 * This mirrors the legacy Imago Admin `login/auth/:apitoken` route.
 *
 * Must be rendered OUTSIDE the AccessTokenGuard: on arrival there is no stored
 * token yet, so the guard would otherwise redirect to /login before we can save
 * the token from the URL. The token is saved and the navigation issued in the
 * same effect, so the stored token is in place before the guarded route renders.
 */
export const AuthCallback = () => {
    const { apiToken } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (apiToken) {
            setCombinedToken({
                access_token: apiToken,
                token_type: LEGACY_TOKEN_TYPE,
            } as AccessAndIDTokenResponse);
            navigate(ROUTES.ROOT_PATH, { replace: true });
        } else {
            navigate(ROUTES.LOGIN, { replace: true });
        }
    }, [apiToken, navigate]);

    return null;
};
